import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useFundsCalculator from '../../hooks/useFundsCalculator';
import { updateCalculatedFunds } from '../../store/actionCreators/fundsActions';

/**
 * FundsProvider component ensures funds data is calculated and available globally
 * Add this component to your app's root to ensure funds data is always available
 */
const FundsProvider = ({ children }) => {
  const dispatch = useDispatch();
  
  // Use the funds calculator hook to keep funds data up to date
  const calculatedFunds = useFundsCalculator();
  
  // Get raw funds data and position metrics to detect changes
  const fundsData = useSelector(state => state.funds.fundsViewV2);
  const positionMetrics = useSelector(state => state.portfolio.positionMetrics);
  
  // Update calculated funds whenever raw data changes
  useEffect(() => {
    if (fundsData || positionMetrics) {
      dispatch(updateCalculatedFunds());
    }
  }, [fundsData, positionMetrics, dispatch]);
  
  // Add a listener for WebSocket updates that might affect funds
  useEffect(() => {
    const handleWebSocketFundsUpdate = (data) => {
      if (data && data.type === 'funds') {
        dispatch(updateCalculatedFunds());
      }
    };
    
    // Add listener for custom events (example - adjust based on your WebSocket implementation)
    window.addEventListener('ws-funds-update', handleWebSocketFundsUpdate);
    
    return () => {
      window.removeEventListener('ws-funds-update', handleWebSocketFundsUpdate);
    };
  }, [dispatch]);
  
  // Simply render children - this component just ensures funds are calculated
  return (
    <>{children}</>
  );
};

export default FundsProvider; 